// extracted by mini-css-extract-plugin
module.exports = {"main_container":"SuccessModal_styles_main_container__MRnTW"};